export default __webpack_public_path__ + "f34eed4fbb39c696d7808bfeee4f6195.svg";